import * as React from "react";
import styles from "./index.module.scss";
import Image from "next/image";
import { useEffect, useState, useRef } from "react";
import { NextPage, GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import Head from "next/head";
import dynamic from "next/dynamic";
import Layout from "@/components/layout";
import { useWidth } from "@/utils/resize";
import Item from "antd/lib/list/Item";

const Index = () => {
  const { t, i18n } = useTranslation("nav");
  const { width, display } = useWidth();
  const urls = [
    {
      title: "About",
      children: [
        { title: "About Us", href: "/about-us" },
        { title: "Privacy Policy", href: "/privacy-policy" },
        { title: "Terms of Service", href: "/terms" },
        { title: "Affiliate Program", href: "/affiliate-program", mobileHide: true, },
      ],
    },
    {
      title: "Features",
      children: [
        { title: "Pick Influencers", href: "/tiktok-influencer-marketing" },
        { title: "Find Products", href: "/tiktok-products-trends" },
        { title: "Discover Videos", href: "/tiktok-videos-analytics" },
        {
          title: "Analyze Shops",
          href: "/tiktok-shops-analytics",
          mobileHide: true,
        },
        {
          title: "TikTok Ads",
          href: "/tiktok-ads-analytics",
          mobileHide: true,
        },
      ],
    },
    {
      title: "Resources",
      children: [
        { title: "Blogs", href: "/blogs" },
        { title: "Reports", href: "/tiktok-reports" },
        { title: "Posts", href: "/posts" },
        { title: "Pricing", href: "/pricing" },
      ],
    },
  ];

  return (
    <Layout header={true} footer={true}>
      <Head>
        <title>{t("sitemap Title")}</title>
        <meta name="keywords" content={t("sitemap Keywords")}></meta>
        <meta name="description" content={t("sitemap Description")} />
        <script src="/js/jq.js" async />
        <script src="/js/kefu53.js" async />
      </Head>
      <div className="defeaultContainer pt-[142px] pb-[300px] lg1024:pb-[130px]">
        <div className="flex flex-wrap lg1024:px-[20px]">
          {urls.map((item) => (
            <div className="w-[300px] lg1024:w-[50%]" key={item.title}>
              <h2 className="mb-[50px] text-[20px] font-bold">{item.title}</h2>
              <div className="flex flex-col">
                {item.children.map(
                  (it) =>
                    (width > 1024 || !it.mobileHide) && (
                      <a
                        key={it.title}
                        href={it.href}
                        className="block mb-[29px] text-[16px] !text-[#191919]"
                      >
                        {t(it.title)}
                      </a>
                    )
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { locale } = context;
  return {
    props: {
      ...(await serverSideTranslations(locale as string, [
        "home",
        "common",
        "nav",
        "footer",
      ])),
      context: {
        locale,
        req: {
          headers: context.req.headers,
        },
      },
    },
  };
};

export default Index;
